<style>
.dropdown-menu{
  top: 20px;
  right: -2px
}
.dropdown-hub{
  height: 355px;
  max-height: 251px;
  overflow-x: hidden;
}
</style>

<template>
  <div class="breadcrumb">
    <vue-element-loading spinner="mini-spinner" color="#FF6700" :active.sync="allhubLoading" />
    <ul>
      <li v-for="(breadcrumb, idx) in breadcrumbList" :key="idx" @click="routeTo(idx)" :class="{'linked': !!breadcrumb.link}">
        {{ breadcrumb.name }}
      </li>

      <li v-if="this.hubAccess.length<2" style="right: 2%; position: absolute;"><b>Logged In Hub:</b>&nbsp;{{hub}}</li>
      <div style="width: 90%;display: flex; justify-content: flex-end;">
      <li v-if="this.hubAccess.length>1" style="right: 8%; width: 28%; position: absolute;"><b>Change Hub:</b>&nbsp;
        
        <vue-element-loading spinner="mini-spinner" color="#FF6700" :active.sync="allhubLoading" />
        <Multiselect v-model="hubdropdown" placeholder="Select Hub"
        :options="hubAccess"  label="HubName" 
          :multiple="false" @input = "setHUBAccess()"
          name="hubdropdown" id="hubdropdown" :optionHeight="100" :hide-selected="true">
          <template slot="noResult"><p>No Record Found.</p></template>
          </Multiselect>                
        <!-- <Multiselect :options="hubAccess" @input="setHUBAccess()" name="hubdropdown" id="hubdropdown" 
        v-model="hubdropdown" placeholder="Select Hub" label="HubName" 
        track-by="HubID" :optionHeight="100" :hide-selected="true" 
        style="margin: 2px -95px 9px 15px; width: 90%; margin-right: -92px;">
           <template slot="noResult"><p>No Record Found.</p></template>
        </Multiselect> -->
      
      </li>
      </div>
    </ul>
  </div>
</template>


<script>
import CryptoJS from 'crypto-js';
import apiUrl from '../constants'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'  

export default {
  name: 'Breadcrumb',
  components: {
      Multiselect,
      VueElementLoading,
      BasicSelect
  },
  data () {
    return {
      allhubLoading:false,
      breadcrumbList: [],
      hub:[],
      userToken:'',
      userdetail:'',
      HubId:'',
      hubAccess:[],
      hubdropdown:[],
    }
  },
  async mounted () {
    await this.updateList();

    var hubEncrypt  = window.localStorage.getItem('accesshubdata')
    var hubbytes    = CryptoJS.AES.decrypt(hubEncrypt.toString(), 'Key');
    var hubtext     = hubbytes.toString(CryptoJS.enc.Utf8);
    var hubArr      = JSON.parse(hubtext);
    this.hub        = hubArr[0].HubName;
    this.hubdropdown= hubArr[0];
    this.hubAccess = hubArr
    // console.log(this.hubdropdown)

    this.userToken = window.localStorage.getItem('accessuserToken').replace(/"/g, '');

    let userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    let bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    this.userdetail       = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    await this.getHUBAccess();
  },
  watch: { async '$route' () { await this.updateList() } },
  methods: {
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
    },
    async updateList () { this.breadcrumbList = this.$route.meta.breadcrumb },
    async  populateData(data) {
      this.hubAccess = data
    },
    async getHUBAccess() {
      this.allhubLoading = true
      // console.log(this.hubAccess)
      var hubEncrypt1  = window.localStorage.getItem('accesshubdata')
      var hubbytes1    = CryptoJS.AES.decrypt(hubEncrypt1.toString(), 'Key');
      var hubtext1     = hubbytes1.toString(CryptoJS.enc.Utf8);
      var hubArr1      = JSON.parse(hubtext1);
      this.hubAccess = hubArr1
      // console.log(this.hubAccess)
      // await axios({
      //     method: 'POST',
      //     url: apiUrl.api_url + 'external/getHUBAccess',
      //     data: { userid:this.userdetail.userid, username:this.userdetail.username },
      //     headers: {
      //       'Authorization': 'Bearer '+this.userToken
      //     }
      //   })
      //   .then(async result => {

      //     if(result.data.code==200){
      //       // this.hubAccess = result.data.data;
      //       await this.populateData(result.data.data)
      //       window.localStorage.setItem('accesszone', result.data.ZoneArr);
      //     }else{
      //       this.hubAccess = [];
      //     }
      //     this.allhubLoading = false
      //   }, error => {
      //     console.error(error)
      //   })
        this.allhubLoading = false
    },

    async setHUBAccess() {
      try {
      let HubObj = '';
      HubObj = this.hubdropdown;
      // console.log(HubObj)
      if(this.hubdropdown === null){
        return
      }
      const findHubIndex = this.hubAccess.findIndex(obj => obj.HubID === this.hubdropdown.HubID);
      if (findHubIndex > 0) {
          const temp = this.hubAccess[0];  
          this.hubAccess[0] = this.hubAccess[findHubIndex]; 
          this.hubAccess[findHubIndex] = temp;
      }
      let hubEncrypt = CryptoJS.AES.encrypt(JSON.stringify(this.hubAccess), "Key");
      window.localStorage.setItem('accesshubdata', '');
      window.localStorage.setItem('accesshubdata', hubEncrypt);
      this.$alertify.success("Hub Updated Successfully");
      if(window.localStorage.getItem('accesshubdata')){
        //document.getElementById('logout').click();
        location.reload();
      }
      this.allhubLoading = false
      // this.$alertify.success(result.data.msg);
      this.allhubLoading = false
      // await axios({
      //     method: 'POST',
      //     url: apiUrl.api_url + 'external/setHUBAccess',
      //     data: { HubID: HubObj.HubID, userid:this.userdetail.userid, username:this.userdetail.username },
      //     headers: {
      //       'Authorization': 'Bearer '+this.userToken
      //     }
      //   })
      //   .then(result => {
      //     if(result.data.code==200){

      //       let newArr = []; 
      //       newArr.push(HubObj);
      //       // let hubEncrypt = CryptoJS.AES.encrypt(JSON.stringify(newArr), "Key");
      //       // window.localStorage.setItem('accesshubdata', '');
      //       // window.localStorage.setItem('accesshubdata', hubEncrypt);

      //       if(window.localStorage.getItem('accesshubdata')){
      //         //document.getElementById('logout').click();
      //         location.reload();
      //       }
      //       this.allhubLoading = false
      //       this.$alertify.success(result.data.msg);
      //       //this.$alertify.success('Hub Updated Successfully, Please Re-login.');
      //     }else{
      //       this.$alertify.error(result.data.msg);
      //     }
      //     this.allhubLoading = false
      //   }, error => {
      //     console.error(error)
      //   })
        this.allhubLoading = false
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style scoped>
  .breadcrumb {}
  ul {
    display: flex;
    justify-content: left;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color: $default;
  /*  font-weight: bold; */
    font-size: 1em;
    cursor: default;
    align-items: center;
  }
  ul > li:not(:last-child)::after {
    content: '/';
    float: right;
    font-size: .8em;
    margin: 0 .5em;
    color: $light-default;
    cursor: default;
  }
  .linked {
    cursor: pointer;
    font-size: 1em;
    font-weight: normal;
    color:#4b8cbb !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue?bcda5e64